export const BOX_1 = require('./box1.png'); 
export const BOX_2 = require('./box2.png'); 
export const LEFT_CHARACTER = require('./left_character.png'); 
export const RIGHT_CHARACTER = require('./right_character.png'); 
